export default __webpack_public_path__ + "static/media/twitter_orange.5625cccd.svg";